import PropTypes from 'prop-types'
import { useState, useEffect, useCallback, useContext } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { LoginContext } from '../context/loginContext'
import ImagenPerfil from '../imagen/ImagenPerfil'
import Upload from '../perfil/Upload'
import * as domiciliosService from '../servicios/domiciliosService'
import * as reputacionService from '../servicios/reputacionService'
import * as usuarioService from '../servicios/usuarioService'
import LinkButton from '../ui/LinkButton'

const ESTRELLAS_REPUTACION = 5

const Hero = (props) => {
  const [datos, setDatos] = useState([])
  const [reputacion, setReputacion] = useState([])
  const [domicilios, setDomicilios] = useState([])
  const [show, setShow] = useState(false)
  const idTipo = 3

  const { loginDataContext } = useContext(LoginContext)
  const tipoUsuario = loginDataContext.tipoUsuario
  const userId = parseInt(localStorage.getItem('idUsuario'))

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) {
        return
      } // Don't make API calls if no user ID

      const { data: reputacion } = await reputacionService.buscarReputacion(userId)
      setReputacion(reputacion)
      const { data: domicilios } = await domiciliosService.buscarTodas(
        userId,
        tipoUsuario
      )
      setDomicilios(domicilios)
      const { data: datos } = await usuarioService.buscarPorId(userId)
      setDatos(datos)
    }
    fetchData()
  }, [tipoUsuario, userId])

  const obtenerReputacionPromedio = useCallback(
    (reputacionData) => {
      let reputacionPromedio
      if (reputacionData === 0) {
        reputacionPromedio = 0
      } else {
        const arrayReputacionPromedio = reputacion.map((e) => e.promedioReputacion)
        //Se trae valor en escala 1-5 (estrellas) y se multiplica el valor * 10 para llevarlo a escala 0 - 100.
        reputacionPromedio = (arrayReputacionPromedio[0] * 100) / ESTRELLAS_REPUTACION
      }
      return reputacionPromedio
    },
    [reputacion]
  )

  const abrirModal = useCallback(() => {
    setShow(true)
  }, [])

  const cerrarModal = useCallback(() => {
    setShow(false)
    //imagen();
    props.cambiarImagenPerfil()
  }, [props])

  const domicilio = domicilios.filter((d) => d.domicilioPrincipal === true)
  const direccionPrincipal = domicilio.map((d) => d.calle)
  const altura = domicilio.map((d) => d.calleAltura)

  return (
    <div className="row mt-4 ml-auto mr-auto borde-perfil">
      <div className="col-12 col-md-6 contenedor-uno-administrar-domicilios">
        <div className="row no-gutters-administrar-domicilios">
          <div className="col-2 text-right-administrar-domicilios">
            <div className="cont-perfil-img">
              <button onClick={abrirModal} className="contenedor-perfil-img-grande">
                <ImagenPerfil idUsuario={userId} clase="perfil-img-grande"></ImagenPerfil>
              </button>
              <LinkButton className="btn cont-perfil">
                <h3 className="perfil-grande f-black ">
                  {datos.nombre} {datos.apellido}{' '}
                </h3>
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6 contenedor-dos-administrar-domicilios">
        <div className="contenedorReputacion row d-flex">
          <div className="col-6 mt-2 d-flex">Reputacion Vendedor</div>
          <div className="d-flex mr-2">
            <meter
              className="meter mr-4 mt-2"
              min="0"
              max="100"
              low="30"
              high="70"
              optimum="100"
              value={obtenerReputacionPromedio(reputacion).toString()}
            ></meter>
            {reputacion.length === 0 ? '0' : obtenerReputacionPromedio(reputacion)}%
          </div>
        </div>

        <div className="row">
          <div className="col-6 mt-2">Dirección Principal</div>
          <div className="col-6 mt-2 text-right">
            {direccionPrincipal} &nbsp; {altura}
          </div>
        </div>
      </div>

      <Modal
        id="crearLista"
        className="modal-dialog crearLista"
        show={show}
        toggle={props.toggle}
        onHide={cerrarModal}
      >
        <Modal.Header closeButton onClick={cerrarModal}>
          <p>Cambiá tu foto de perfil</p>
        </Modal.Header>
        <Modal.Body>
          <Upload accept={'image/*'} idTipo={idTipo} idUsuario={userId} />
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="button"
            onClick={cerrarModal}
            id="btnBordeRojo"
            data-dismiss="modal"
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default Hero

Hero.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired,
  toggle: PropTypes.func
}
